if (!customElements.get('numeric-range')) {
  /**
   * Range slider over a Shopify list-type numeric metafield filter.
   * Toggles hidden checkboxes inside the filter form so the form
   * submits as a normal multi-value list filter URL.
   */
  class NumericRange extends HTMLElement {
    constructor() {
      super();
      if (window.initLazyScript) {
        window.initLazyScript(this, this.init.bind(this));
      } else {
        this.init();
      }
    }

    init() {
      this.minNumberInput = this.querySelector('.numeric-range__number-min');
      this.maxNumberInput = this.querySelector('.numeric-range__number-max');
      this.minSliderInput = this.querySelector('.numeric-range__slider-min');
      this.maxSliderInput = this.querySelector('.numeric-range__slider-max');

      if (!this.minNumberInput || !this.maxNumberInput || !this.minSliderInput || !this.maxSliderInput) {
        return;
      }

      this.minBound = Number(this.minNumberInput.min);
      this.maxBound = Number(this.maxNumberInput.max);
      this.minSpread = Number(this.dataset.minSpread || 1);
      this.listMode = this.dataset.listMode === 'true';
      this.checkboxes = Array.from(this.querySelectorAll('.numeric-range__checkbox'));
      this.addEventListener('input', this.handleInput.bind(this));
    }

    handleInput(evt) {
      this.updateSliderInputs(evt);
      this.updateNumberInputs();
      if (this.listMode) {
        this.syncCheckboxes();
      }
    }

    updateNumberInputs() {
      this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
        ? this.minSliderInput.value : this.minBound;
      this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max
        ? this.maxSliderInput.value : this.maxBound;
    }

    updateSliderInputs(evt) {
      const spread = this.minSpread;
      const minValue = parseInt(this.minNumberInput.value, 10);
      const maxValue = parseInt(this.maxNumberInput.value, 10);

      if (minValue > maxValue - spread) {
        if (evt.target === this.minNumberInput) {
          this.maxSliderInput.value = minValue + spread;
          if (maxValue === this.maxBound) {
            this.minSliderInput.value = this.maxBound - spread;
          }
        } else {
          this.minSliderInput.value = maxValue - spread;
        }
      }

      if (maxValue < minValue + spread) {
        if (evt.target === this.maxNumberInput) {
          this.minSliderInput.value = maxValue - spread;
          if (minValue === this.minBound) {
            this.maxSliderInput.value = spread;
          }
        } else {
          this.maxSliderInput.value = minValue + spread;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
      }
      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
      }
    }

    syncCheckboxes() {
      let min = parseInt(this.minSliderInput.value, 10);
      let max = parseInt(this.maxSliderInput.value, 10);
      if (min > max) {
        const tmp = min; min = max; max = tmp;
      }
      const fullRange = min <= this.minBound && max >= this.maxBound;
      this.checkboxes.forEach((cb) => {
        const val = parseInt(cb.dataset.numericValue, 10);
        cb.checked = !fullRange && val >= min && val <= max;
      });
    }
  }

  customElements.define('numeric-range', NumericRange);
}
